import * as Redux from 'redux';
import * as Actions from "./store/actions";
import * as Helpers from './communication/PlatformHelpers';
import format from 'date-fns/format';
import DOMPurify from "dompurify";
import * as _ from "lodash";
// import { remote, desktopCapturer, ipcRenderer, app } from "electron";

// import * as fs from 'fs';
// import * as path from 'path';
import { FeedbackTag, PublicFeedback } from "./PublicFeedback";
import { Settings } from "./Settings";
import { UserSettings } from "./UserSettings";
import { TelemetryHelper, TelemetryResult } from './telemetry/TelemetryHelper';
import { ResourceStrings } from "./ResourceStrings";
import { RootState } from "./store/rootState";
import {
    AppState,
    Dialog,
    FileInfo,
    Filter,
    FollowTab,
    MainView,
    OperationState,
    RapView,
    ReportType,
    SearchInfo,
    SearchInfoTarget,
    Sort,
    SearchTab,
    NotificationInfo,
    RapSource,
} from "./store/appState";
// tslint:disable-next-line:no-submodule-imports

// @TODO: Replace with new equivalent
// import { ErrorHandlerRenderer } from "report-errors-electron/renderer";
// import enableWer from "enable-wer-windows";
import { SearchResult } from "./SearchResults";
import * as Collector from "./DataCollectorConfiguration";
import { ProblemStates, IdeaStates } from "./constants/feedback";

// tslint:disable-next-line:no-var-requires

// @TODO: Replace with new equivalent
// const open = require("open");
// import { spawn } from 'child_process';
// tslint:disable-next-line:no-duplicate-imports
import { CropRect } from "./CropRect";
// @TODO: Replace with new equivalent
//////import { mkdirParentsSync } from "mkdir-parents";

import { TagsResult } from "./TagsResult";
import { Minimark } from "./editor/Minimark";
import { InitResult, platformActions, } from "./communication/Communication";
import { UserInfo, NativeActions, ImageInfo, ScreenshotCropConfig } from './communication/PlatformActions';
import { stringFromErrorOrAny, winFileTimeToJSDate, winFileTimeToJSTimeMsec } from "./utils/tools";
import configureStore from "./store/configureStore";
import { AppPaths, getDevComUrl } from "./constants/urls";
import { loadMeControl, signedOut } from "./meCtrl";
import { History } from "history";
import { ticketReadonlyThresholdDays } from "./constants/config";
import { EntryValue, hashForNodeDirect, UrlParam, referrerNative } from "./constants/urlParams";
import { problemStates } from "./config/problemStates";
import { v4 as uuidv4 } from 'uuid';
import { ideaStates } from "./config/ideaStates";
import { hasItems } from "./utils/collections";
import { getSpaceConfig, getWindowTitle, instance } from "./config/serverConfig";
import { ChildPost, getLastNeedMoreInfoCommentId, hasSystemTag, PostType, PrincipalId, RootPost, StateTag, SystemTags } from './RootPost';
import { UploadedFileInfo, uploadFiles } from './components/shared/FileUpload/FileUpload';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const VSO_RESOURCE_ID: string = "499b84ac-1321-427f-aa17-267ca6975798"; // VS online service principal
const SEARCH_FAILED_RETRY_TIME_MSEC: number = 1000;
const VERSION_AFTER_ELECTRON: number = 20220110; //change made 01/10/2022

export enum SignInState {
    // @TODO: add .Disconnected state for when disconnected from VS
    Executing = 0, // trying to sign in for the first time or sign out then in by customer request
    Success = 1,
    Failed = 2,

    Checking = 3, // verify if the customer is already signed in at app start
    Prompt = 4, // show prompt note to sign in
    Expired = 5, // sign in has expired, ask customer to sign in again

    MicrosoftAccountRequired = 6, // must sign in with @microsoft.com account: ONLY if on corpnet AND not signed in with MS account

    ChooseAccount = 7, // there's more than one account, and user is picking one
}

export class App {
    public static store: Redux.Store<RootState>;
    // @TODO: This should really be kept in redux store as it is mutable data which components need to react to
    public static settings: Settings;
    public static clientBranch: string;
    public static clientBuild: string;
    public static clientName: string;
    public static sourceDialog: string;

    /** temporary read-only app state used by telemetry service, because telemetry service cannot call getState() if called inside the actionHandlers.ts reducer
     * getState() from within telemetry would cause the following error:
     * "Error: You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. 
     * Pass it down from the top reducer instead of reading it from the store."
     */
    public static tempSignInState: SignInState = SignInState.Checking;
    public static telemetry: TelemetryHelper;
    public static previewFeaturesEnabled: boolean = false;
    public static channelManifestId: string;
    // Report uncaught exceptions to the main process
    // public static errorHandler = new ErrorHandlerRenderer();
    public static hasVotedCache: { [trackingId: string]: boolean } = {};

    // true if vsid was missing in last sign in (bug we're looking to log telemetry for)
    // false if vsid was present
    public static hasMissingVsid: boolean = false;
    public static history: History;

    public static parseDate(date: string | Date): Date {
        if (date instanceof Date) {
            return date as Date;
        }

        let dateObj: Date;
        if (date.indexOf("/Date(") === 0) { // if microsoft date format, convert
            const startIndex: number = "/Date(".length;
            try {
                let endIndex: number = date.indexOf('+') - 1;
                if (endIndex < 0) {
                    endIndex = date.length - 3;
                }
                const value: number = parseFloat(date.substr(startIndex, endIndex - startIndex + 1));
                dateObj = new Date(value);
            } catch (ex) {
                const value: number = parseFloat(date.substr(startIndex, date.length - startIndex));
                dateObj = new Date(value);
            }
        } else {
            dateObj = new Date(Date.parse(date));
        }
        return dateObj;
    }

    // Workaround for Riot.JS - checkbox/expand/collapse/selected/other state changes
    // need to be updated AFTER other updates for screen readers to read it
    public static WorkaroundScreenReader(f: () => void): void {
        setTimeout(f, 100);
    }

    public static GetScrollBarWidthPixels(): number {
        // default to 15px server-side as this is true for many browsers
        const inner = document.createElement('p');
        inner.style.width = '100%';
        inner.style.height = '200px';

        const outer = document.createElement('div');
        outer.style.position = 'absolute';
        outer.style.top = '0px';
        outer.style.left = '0px';
        outer.style.visibility = 'hidden';
        outer.style.width = '200px';
        outer.style.height = '150px';
        outer.style.overflow = 'hidden';
        outer.appendChild(inner);

        document.body.appendChild(outer);
        const w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        let w2 = inner.offsetWidth;
        if (w1 === w2) {
            w2 = outer.clientWidth;
        }
        document.body.removeChild(outer);

        return w1 - w2;
    }

    public static GetActiveSearchInfo(state: AppState): SearchInfo {
        switch (state.searchActiveTab) {
            case SearchTab.problems:
                return state.problems;
            case SearchTab.suggestions:
                return state.suggestions;
            default:
                throw new Error(`SearchTab ${state.searchActiveTab} is unknown. When making new tabs, add them here.`);
        }
    }

    public static GetActiveSearchInfoTarget(state: AppState): SearchInfoTarget {
        switch (state.searchActiveTab) {
            case SearchTab.problems:
                return SearchInfoTarget.problems;
            case SearchTab.suggestions:
                return SearchInfoTarget.suggestions;
            default:
                throw new Error(`SearchTab ${state.searchActiveTab} is unknown. When making new tabs, add them here.`);
        }
    }

    /** Parses and formats date as date string only (no time) */
    public static ParseDateToLocal(date: string | Date | number): string {
        return format(
            typeof date === "string" ? App.parseDate(date) : date as (Date | number),
            "MMM dd, yyyy"
        );
    }

    /** Parses and formats date as date string only (no date, no time) */
    public static ParseDateToLocalMonthYear(date: string | Date | number): string {
        return format(
            typeof date === "string" ? App.parseDate(date) : date as (Date | number),
            "MMM yyyy"
        );
    }

    /** Parses and formats Utc date and time as local date and time string */
    public static ParseDateTimeToLocal(date: string | Date | number): string {
        return format(
            typeof date === "string" ? App.parseDate(date) : date as (Date | number),
            "MMM dd, yyyy h:mm a"
        );
    }

    /** Formats date to local date and time string */
    public static FormatDateTime(date: (Date | number)): string {
        return format(date, "MMM dd, yyyy h:mm a");
    }

    public static GetUrlSafeTitle(title: string): string {
        return App.EscapeHtmlRawDisplay(title).substring(0, 40).trim().replace(/\s/g, "-").replace(/[`'".?,/\\~!@#$%^&*+=|()<>{}[\]]/g, "");
    }

    public static EscapeHtmlRawDisplay(html: string): string {
        return DOMPurify.sanitize(html);
    }

    public static GetPublicFeedbackSiteLink(): string {
        return "<a href='https://go.microsoft.com/fwlink/?LinkId=868937' target='_blank' rel='noopener noreferrer'>" + ResourceStrings.publicFeedbackSite() + "</a>";
    }

    public static StripAllHtml(html: string): string {
        return App.EscapeHtmlRawDisplay(html);
    }

    public static HtmlFromMarkdownIfNeeded(htmlOrMarkdown: string | null): string {
        if (htmlOrMarkdown == null) {
            return "";
        }

        // search results text includes <sh> tags which prevents urls from being shown as links if url is part of search text
        // we are not using <sh> tags so remove them
        htmlOrMarkdown = htmlOrMarkdown.replace(/<sh>/g, "").replace(/<\/sh>/g, "");
        htmlOrMarkdown = Minimark.HtmlFromMarkdown(htmlOrMarkdown);
        htmlOrMarkdown = "<markdown>" + htmlOrMarkdown + "</markdown>";

        return htmlOrMarkdown;
    }

    public static GetUserProfileLink(vsIdOrId: string | PrincipalId): string {
        return `${AppPaths.user}/${vsIdOrId}`;
    }

    public static GetSolutionAndVotesText(item: SearchResult): string {
        return ResourceStrings.solutionsAndVotes(item.solutionCount, item.totalVotes);
    }

    public static CouldReactivateSolutionEver = (solution: ChildPost): boolean =>
        solution.couldReactivateEver;

    // Parses a string date (UTC) and returns a string formatted in local date format
    public static ParseDateToLocalDateTime(date: string): string {
        return App.parseDate(date).toLocaleString();
    }

    // Parses a string date (UTC) and returns a string formatted in local date format
    public static ParseDateToLocalDate(date: string): string {
        return App.parseDate(date).toLocaleDateString();
    }

    public static CountComments(comments: ChildPost[]): number {
        let count: number = 0;
        comments.forEach((comment) => {
            if (comment.type === PostType.comment) {
                count++;
            }
            count += App.CountComments(comment.children);
        });
        return count;
    }

    private static isValidLink(url: string): boolean {
        if ((url == null) || (url === "")) {
            return false;
        }
        // eslint-disable-next-line @microsoft/sdl/no-insecure-url
        return url.startsWith("http://") || url.startsWith("https://") || url.startsWith("mailto:");
    }

    public static openUnsafe(url: string): void {
        // Supress false positive: https://github.com/nodesecurity/eslint-plugin-security/issues/13
        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url);
    }

    public static openSafe(url: string): void {
        if (App.isValidLink(url)) {
            // Supress false positive: https://github.com/nodesecurity/eslint-plugin-security/issues/13
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(url);
        }
        else {
            App.showMessageBox(ResourceStrings.incorrectLink(url));
        }
    }

    public static showMessageBox(text: string): void {
        alert(text); // TODO: make this better
    }

    private static stateMapProblems: { [stateKey: string]: string } | null = null;
    private static stateMapIdeas: { [stateKey: string]: string } | null = null;

    public static LocalizeStateName(stateKey: string, commentType: PostType): string {
        if ((stateKey == null) || (stateKey.length === 0)) {
            return ResourceStrings.stateUnknown();
        }

        if (App.stateMapProblems == null) {
            App.stateMapProblems = {
                [ProblemStates.fixed]: ResourceStrings.stateFixed(),
                [ProblemStates.duplicate]: ResourceStrings.stateDuplicate(),
                [ProblemStates.wontFix]: ResourceStrings.stateWontFix(),
                [ProblemStates.willNotFix]: ResourceStrings.stateWillNotFix(),
                [ProblemStates.moreInfo]: ResourceStrings.stateMoreInfo(),
                [ProblemStates.new]: ResourceStrings.stateNew(),
                [ProblemStates.investigation]: ResourceStrings.stateInvestigating(),
                [ProblemStates.triaged]: ResourceStrings.stateAccepted(),
                [ProblemStates.pending]: ResourceStrings.statePendingRelease(),
                [ProblemStates.notABug]: ResourceStrings.stateNotBug(),
                [ProblemStates.notEnoughInfo]: ResourceStrings.stateNotEnoughInfo(),

                // new states for VS 2017 RTW:
                [ProblemStates.future]: ResourceStrings.stateFuture(),
                [ProblemStates.closedFuture]: ResourceStrings.stateClosedFuture(),
                [ProblemStates.lowerPriority]: ResourceStrings.stateClosedLowPri(),
                [ProblemStates.otherProduct]: ResourceStrings.stateClosedOtherProduct(),
                [ProblemStates.infoGiven]: ResourceStrings.stateInfoGiven(),
                [ProblemStates.pendingRelease]: ResourceStrings.statePendingReleaseShort(),
                [ProblemStates.reopen]: ResourceStrings.stateReopen(),

                // new states for VS 2017 version 15.4 preview 2
                [ProblemStates.consideration]: ResourceStrings.stateUnderConsideration(),
                [ProblemStates.suggestion]: ResourceStrings.stateClosedSuggestion(),
            };
        }

        if (App.stateMapIdeas == null) {
            App.stateMapIdeas = {
                [IdeaStates.closed]: ResourceStrings.ideaStateClosed(),
                [IdeaStates.duplicate]: ResourceStrings.ideaStateDuplicate(),
                [IdeaStates.notEnoughInfo]: ResourceStrings.ideaStateNotEnoughInfo(),
                [IdeaStates.otherProduct]: ResourceStrings.ideaStateOtherProduct(),
                [IdeaStates.pending]: ResourceStrings.ideaStatePending(),
                [IdeaStates.fixed]: ResourceStrings.ideaStateFixed(),
                [IdeaStates.moreInfo]: ResourceStrings.ideaStateMoreInfo(),
                [IdeaStates.new]: ResourceStrings.ideaStateNew(),
                [IdeaStates.investigation]: ResourceStrings.ideaStateInvestigation(),
                [IdeaStates.consideration]: ResourceStrings.ideaStateConsideration(),
                [IdeaStates.outOfScope]: ResourceStrings.ideaStateOutOfScope(),
            };
        }

        stateKey = stateKey.toLowerCase();
        let mapToUse: { [stateKey: string]: string } = {};

        switch (commentType) {
            case PostType.suggestion:
                mapToUse = App.stateMapIdeas;
                break;
            case PostType.problem:
                mapToUse = App.stateMapProblems;
                break;
            default:
                throw new Error(`No statemap for type ${commentType}, please add one if needed.`);
        }

        // eslint-disable-next-line security/detect-object-injection
        const result = mapToUse[stateKey];
        if (result == null) {
            return stateKey;
        }

        return result;
    }

    constructor(initResult: InitResult, partialInitState: AppState | undefined, telemetryHelper: TelemetryHelper, history: History) {
        App.history = history;

        // Minimum required settings template for search etc. APIs to work.
        // This will be overwritten by native process with actual vaules
        // when submitting new problems for VS or when responding to NMI etc.
        const webSettings: Settings = Object.assign(new Settings(), {
            "isInternal": false,
            "isRecordingDisabled": true,
            "feedbackSessionId": `WEB_${uuidv4()}`,
            "filesToUpload": [],
            "template": {
                "source": RapSource.developerCommunity,      // This will automatically be set to 'Send a smile' if the page is launched from VS
                "tags": []
            }
        });

        App.previewFeaturesEnabled = true;

        App.telemetry = telemetryHelper;
        App.store = configureStore({ ...new AppState(), ...partialInitState }, history);

        // check and display startup error, if any
        if (initResult.error) {
            App.showUnexpectedError(initResult.error, false, true, "Website down");
        }

        App.updateSettings(webSettings);

        document.addEventListener("DOMContentLoaded", () => {
            const body = document.getElementsByTagName('body')[0];
            body.setAttribute("aria-label", getWindowTitle());

            // tslint:disable-next-line:no-unused-expression
            new DisableFocusForRoot(document, document.body);
        });

        App.setTag("feedbackSessionId", App.settings.feedbackSessionId);
        Actions.setAppSettings(_.cloneDeep(App.settings));

        // prevent drag-drop
        document.addEventListener('dragover', (event) => event.preventDefault());
        document.addEventListener('drop', (event) => event.preventDefault());

        // open links externally by default
        // @TODO: Replace with new equivalent
        ////$(document).on('click', 'a[href^="http"]', function (this: any, event) {
        ////    event.preventDefault();
        ////    if (App.isValidLink(this.href)) {
        ////        shell.openExternal(this.href);
        ////    }
        ////    else {
        ////        App.native.showMessageBox(ResourceStrings.incorrectLink(this.href));
        ////    }
        ////});

        // @TODO: Replace with new equivalent
        // remote.getCurrentWebContents().on('will-navigate', (e, url) => {
        //     e.preventDefault();
        //     App.openSafe(url);
        // });

        // load user settings
        const userSettings: UserSettings = App.loadUserSettings();
        Actions.setShowGuidance(userSettings.showGuidance);

        App.telemetry.postBusinessEvent("app-launched", {
            source: App.clientName === "vs-xsetup" ? "Installer" : "VS",
            searchFor: App.settings.initialSearchText || "",
        });

        Actions.rapSetDetail(App.settings.initialReproText || "");

        // Keep store in sync with syslogs in settings
        Actions.rapGetSystemLogsToUpload();

        // @TODO: Do we need this anymore in June Devcom2?
        // Actions.loadIncidents();

        Actions.setSearchNotStarted(SearchInfoTarget.problems);
        Actions.setSearchNotStarted(SearchInfoTarget.suggestions);
        Actions.setHasSearchedTrue(); // ensure we don't double-trigger the check for sign in after first search
        App.checkForSignIn();

        Actions.getApprovedFileExtensions();
    }

    public static updateSettings(settings: Settings, forInitialHelloHandshake: boolean = false): void {
        try {
            // @TODO: Read settings from packaged settigs file
            // Parse json config file on client side to avoid multiple cross-process calls every property access
            const trackingId = App.settings?.template?.trackingId;
            App.settings = settings;
            App.settings.template.trackingId = App.settings.template.trackingId ?? trackingId;
            App.settings.template.version = VERSION_AFTER_ELECTRON; // override API version since we're using API 2022-01
            App.settings.template.text = App.settings.template.text ?? ""; // ensure .text is present for legacy server; TODO: this line can be removed with new backend

            // Set default title & text only during update triggered by initial handshake as a precaution
            // so that any updateSettings call triggered in future don't overwrite any content which user might have typed
            if (forInitialHelloHandshake && (App.settings.initialSearchText || App.settings.initialReproText)) {
                Actions.rapSetTitle(App.settings.initialSearchText ?? "");
                Actions.rapSetDetail(App.settings.initialReproText ?? "");

                App.settings.initialSearchText = null;
                App.settings.initialReproText = null;
            }

            App.settings.template.customerChosenArea = null; // no customer area support in this version
            // Get the calling client name and version (sent in telemetry and used in multiple cases, like upload)
            App.sourceDialog = "";
            App.clientBranch = "";
            App.clientBuild = "unknown";
            App.clientName = "unknown";
            App.channelManifestId = "unknown";
            for (let i = 0; i < App.settings.template.tags.length; i++) {
                // eslint-disable-next-line security/detect-object-injection
                const tag: FeedbackTag = App.settings.template.tags[i];
                if (tag.type === 'product-build-branch') {
                    App.clientBranch = tag.value || "";
                } else if (tag.type === 'product-build') {
                    App.clientBuild = tag.value || "unknown";
                } else if (tag.type === 'product') {
                    App.clientName = tag.value || "unknown";
                } else if (tag.type === 'channel-manifest-id') {
                    App.channelManifestId = tag.value || "unknown";
                } else if (tag.type === 'experiment') {
                    const exp: string = (tag.value || "unknown");
                    // tslint:disable-next-line:triple-equals
                    if (App.settings.capabilities.expFlights === "") {
                        App.settings.capabilities.expFlights = exp;
                    }
                    else {
                        App.settings.capabilities.expFlights += ";" + exp;
                    }
                    if (exp.toLowerCase() === 'vsfreprosteps') {
                        App.settings.reproTextTemplate = ResourceStrings.reproStepsTemplate();
                    }
                } else if (tag.type === 'source-dialog') {
                    App.sourceDialog = tag.value || "";
                }
            }

            const uiLang: string = App.settings.template.uiculture || 'en'; // TODO: pass through URL vars to init at app start, before settings available
            ResourceStrings.config(uiLang, true);
            document.getElementsByTagName("html")[0].setAttribute("lang", uiLang);
            document.title = getWindowTitle();

            App.telemetry?.update(App.settings.dataOptIn, App.clientName, App.clientBuild, App.settings.feedbackSessionId);
            App.startGettingScreenshot();
            Actions.filterFilesToUploadIgnoreErrors();

            // Keep store in sync
            if (App.store) {
                Actions.rapGetSystemLogsToUpload();
            }

            Actions.setAppSettings(_.cloneDeep(App.settings));
        } catch (err) {
            console.error(err);
        }
    }

    static setTicketUrlParameters = (search: string, removeNativeConnectionInfoFromUrl: boolean, referrer: string, userId: string): string => {
        if (!search && !referrer) {
            return search;
        }

        const urlParams = new URLSearchParams(search);
        if (removeNativeConnectionInfoFromUrl) {
            urlParams.delete(UrlParam.Port);
            urlParams.delete(UrlParam.Fsid);
        }

        if (referrer && userId) {
            urlParams.set(UrlParam.Referrer, referrer);
            urlParams.set(UrlParam.ReferrerTimestamp, Date.now().toString());
            urlParams.set(UrlParam.ReferrerUserId, userId);
        }
        return urlParams.toString() ? `?${urlParams.toString()}` : "";
    }

    // get full url to a comment or solution including host e.g. https://developercommunity.visualstudio.com/t/<title>/<id>...
    static getNodeUrl = (answerHubId: number, title: string, nodeId: number, removeNativeConnectionInfo: boolean = false): string =>
        `${App.getTicketUrl(answerHubId, title, removeNativeConnectionInfo)}#${hashForNodeDirect(nodeId)}`;

    // get full url to a ticket including host e.g. https://developercommunity.visualstudio.com/t/<title>/<id>...
    static getTicketUrl = (answerHubId: number, title: string, removeNativeConnectionInfo: boolean = false, addReferrerInfo: boolean = false, userId: string = null): string =>
        `${getDevComUrl()}${App.getTicketPath(answerHubId, title, removeNativeConnectionInfo, addReferrerInfo, userId)}`

    // get url to a ticket relative to devcom2 host e.g. /t/<title>/<id>...
    static getTicketPath = (answerHubId: number, title: string, removeNativeConnectionInfo: boolean = false, addReferrerInfo: boolean = false, userId: string = null, excludeParams: boolean = false): string => {
        let referrerParamValue: string;
        if (addReferrerInfo && platformActions.getNativeActions() != null) {
            referrerParamValue = referrerNative;
        }

        const safeTitle = App.GetUrlSafeTitle(title);
        const search = excludeParams ? '' : App.setTicketUrlParameters(window.location.search, removeNativeConnectionInfo, referrerParamValue, userId);
        return `${AppPaths.t}/${safeTitle}/${answerHubId}${search}`;
    }

    static getTicketPathWithoutParams = (answerHubId: number, title: string): string => App.getTicketPath(answerHubId, title, undefined, undefined, undefined, true);

    public static signInPrompt(isNotification: boolean): void {
        if (isNotification) {
            App.telemetry.postOperation("SignInShowNeeded_Notification", TelemetryResult.None);
        }
        else {
            App.telemetry.postOperation("SignInShowNeeded", TelemetryResult.None);
        }

        App.clearSignInData();
        Actions.setSignInState(SignInState.Prompt);
    }

    public static signInFailed(error: string, isNotification: boolean): void {
        if (isNotification) {
            App.telemetry.postUserTask("SignIn_Notification", TelemetryResult.Failure);
        }
        else {
            App.telemetry.postUserTask("SignIn", TelemetryResult.Failure);
        }
        App.telemetry.postCriticalFault("SignInException", (error || "Unknown").toString());

        App.clearSignInData();
        Actions.setSignInState(SignInState.Failed, error || ResourceStrings.errorUnknown());

        // Sign out user in UHF header
        signedOut();

        if (!App.settings.isInternal) { // if `maybe external` user
            App.initializeHomePage();
        }
    }

    // User signed out from IDE
    public static signOutComplete(): void {
        App.clearSignInData();
        Actions.setSignInState(SignInState.Prompt);

        // Sign out user in UHF header
        signedOut();
    }

    public static chooseAccountIfNeeded(users: UserInfo[], isNotification: boolean): void {
        if (users.length === 1) { // if just one user account signed in, nothing to choose
            // also, choosing account for single user is not supported on some feedback.exe-s, but >= 2 users supports choosing accounts
            App.signInComplete(users[0], isNotification);
            return;
        }

        Actions.setAccounts(users);
        Actions.setSignInState(SignInState.ChooseAccount);
    }

    public static signInComplete(result: UserInfo, isNotification: boolean): void {
        const native: NativeActions = platformActions.getNativeActions();

        const perfProps = this.settings.loadStartMsec
            ? {
                loadStartMsec: this.settings.loadStartMsec.toString(),
                loadStartDate: winFileTimeToJSDate(this.settings.loadStartMsec).toISOString(),
                signinCompleteDurationMsec: (Date.now() - winFileTimeToJSTimeMsec(this.settings.loadStartMsec)).toString(),
                nativeProcessAvailable: (!!native).toString(),
            }
            : {};

        // isNotification will be true if we have a system notification (e.g. signed in from VS instead of feedback console)
        if (isNotification) {
            App.telemetry.postUserTask("SignIn_Notification", TelemetryResult.Success, undefined, undefined, {
                "CredentialsExpired": result.stale.toString(),
                ...perfProps,
            });
        } else {
            App.telemetry.postUserTask("SignIn", TelemetryResult.Success, undefined, undefined, {
                "CredentialsExpired": result.stale.toString(),
                ...perfProps,
            });
        }

        App.updateSignInData(result);

        let hasSucceeded: boolean = false;
        if (result.vsid == null || result.vsid === "" || (result.vsid.indexOf('00000000-0000-0000-0000-000000000000') >= 0)) {
            App.hasMissingVsid = true;
            App.telemetry.postFault("SignInExpiredNoVsid", "No vsid found");
            Actions.setSignInState(SignInState.Expired);
        }
        else {
            if (App.hasMissingVsid) { // if we signed in OK after having a missing Vsid
                App.hasMissingVsid = false;
                App.telemetry.postOperation("SignInRecovered", TelemetryResult.Success, "Recovered sign in after missing VSID");
            }

            // we have valid vsid
            if (result.stale) {
                Actions.setSignInState(SignInState.Expired);
            }
            else {
                const userName: string = result.name || ResourceStrings.userUnknown();
                const isMicrosoftAccount = App.isMicrosoftAccount(result.email);
                if ((App.settings.isInternal && !isMicrosoftAccount)) { // if on corpnet and not @microsoft account
                    Actions.setSignInState(SignInState.MicrosoftAccountRequired);
                }
                else {
                    const userLogoBase64: string | null = result.logo;
                    if (App.settings.isInternal || isMicrosoftAccount) { // for Microsoft internal users determine if their feedback goes Public or Internal and based on that show proper message when submitting
                        const name = instance.isInternal ? userName : (userName.indexOf("MSFT") > 0 ? userName : userName + " [MSFT]");
                        loadMeControl(name, result.email, result.vsid, false, result.providerId);
                        Actions.setSignInState(SignInState.Success, "", name, result.email, result.vsid, result.providerId, userLogoBase64);
                        if (App.clientBranch && App.clientBuild) {
                            // If we connect via Web then we won't have any build information
                            // We don't let users submit VS feedback when not connected to VS anyway so this won't matter much
                            // as this is used just to inform the internal users that any new feedback that they submit will be public
                            Actions.setRoutingMessage(App.clientBranch, App.clientBuild);
                        }
                    }
                    else {
                        loadMeControl(userName, result.email, result.vsid, false, result.providerId);
                        Actions.setSignInState(SignInState.Success, "", userName, result.email, result.vsid, result.providerId, userLogoBase64);
                    }
                    hasSucceeded = true;
                }
            }
        }

        if (hasSucceeded) {
            Actions.loadUserProperties();
            Actions.getUserMetadata();
        }

        if (!App.settings.isInternal || hasSucceeded) { // if external or sign in succeeded. Note: internal users can't search if not signed in
            App.initializeHomePage();
        }
    }

    private static loadMoreIfNeeded(searchFor: string,
        info: SearchInfo,
        target: SearchInfoTarget,
        sort: Sort | null,
        filter: Filter | null,
        returnTotalCount: boolean = false): void {
        const nowMsec: number = new Date().getTime();
        if (info.results.results.length === 0) { // if no first search yet
            return;
        }

        if ((info.state === OperationState.Success) &&
            info.loadedEverything) { // if loaded everything
            return;
        }

        if (
            (info.state === OperationState.Success) ||
            ((info.state === OperationState.Failed) &&
                (nowMsec - info.lastSearchTimeMsec > SEARCH_FAILED_RETRY_TIME_MSEC)) // if last search was successful or we failed some time ago
        ) {
            const options: Actions.SearchOptions = new Actions.SearchOptions();
            options.skip = info.results.results.length;
            options.sort = sort;
            options.filter = filter;
            options.returnTotalCount = returnTotalCount;

            Actions.searchFor(searchFor, target, options);
        }
    }

    private static loadMoreActivityIfNeeded(info: SearchInfo): void {
        const nowMsec: number = new Date().getTime();
        if (info.activityResults.activities.length === 0) { // if no first search yet
            return;
        }

        if ((info.state === OperationState.Success) &&
            info.loadedEverything) { // if loaded everything
            return;
        }

        if (
            (info.state === OperationState.Success) ||
            ((info.state === OperationState.Failed) &&
                (nowMsec - info.lastSearchTimeMsec > SEARCH_FAILED_RETRY_TIME_MSEC)) // if last search was successful or we failed some time ago
        ) {
            const fullPageCountLoaded: number = Math.floor(info.activityResults.activities.length / Actions.ACTIVITY_PAGE_SIZE);
            const partialResultCountLoaded: number = info.activityResults.activities.length % Actions.ACTIVITY_PAGE_SIZE;
            const pagesLoaded: number = partialResultCountLoaded > 0 ? fullPageCountLoaded + 1 : fullPageCountLoaded;
            Actions.loadActivity(pagesLoaded + 1); // added +1 since AnswerHub starts from 1
        }
    }

    private static loadMoreSearchResultsIfNeeded(): void {
        console.log("loadMoreSearchResultsIfNeeded()...");
        const state: AppState = App.store.getState().appState as AppState;
        App.loadMoreIfNeeded(App.GetActiveSearchInfo(state).searchtext, App.GetActiveSearchInfo(state), App.GetActiveSearchInfoTarget(state), null, null);
    }

    private static loadMoreItemsTheyFollowIfNeeded(): void {
        console.log("loadMoreItemsTheyFollowIfNeeded()...");
        const state: AppState = App.store.getState().appState as AppState;
        if (state.followActiveTab === FollowTab.myProblems) {
            App.loadMoreIfNeeded("", state.myProblems, SearchInfoTarget.myProblems, Sort.active, Filter.follow, true);
        } else if (state.followActiveTab === FollowTab.mySuggestions) {
            App.loadMoreIfNeeded("", state.myProblems, SearchInfoTarget.mySuggestions, Sort.active, Filter.follow, true);
        } else if (state.followActiveTab === FollowTab.all) {
            App.loadMoreIfNeeded("", state.myProblems, SearchInfoTarget.all, Sort.active, Filter.follow, true);
        }
        else { // my activity
            App.loadMoreActivityIfNeeded(state.myActivity);
        }
    }

    public static isMicrosoftAccount(email: string): boolean {
        // validate e.g. name@ntdev.microsoft.com name@microsoft.com etc.
        email = email.toLowerCase();
        if (email.endsWith("@microsoft.com")) {
            return true;
        }

        const indexOfAt = email.indexOf('@');
        if (indexOfAt < 0) {
            return false;
        }

        if (email.endsWith(".microsoft.com")) {
            return true;
        }

        return false;
    }

    public static requestSignOutAndIn(onSuccess: (() => void) | null = null): void {
        Actions.setSignInSuccessAction(onSuccess);
        Actions.setSignInState(SignInState.Executing);
        const native: NativeActions = platformActions.getNativeActions();
        if (native == null) {
            // non-native (web) sign out/in will redirect website to another URL.
            // Avoid any further processing to prevent infinite loop during automatic sign-in for internal instance
            platformActions.signOutAndIn();
        }
        else {
            Helpers.processSignInPromise(platformActions.signOutAndIn(), false);
        }
    }

    private static updateSignInData(user: UserInfo): void {
        App.setTag("vs-otuid", user.vsid);
        App.setTag("vote-userid", `vsId:${user.vsid}`);
        App.setTag("vs-providerid", user.providerId);
        App.setTag("vsts-email", user.email);
        App.setTag("vsts-displayname", user.name); // used to create users with this .name in AH
        App.settings.template.user = user.email; // used to create users with this .email in AH
        Actions.setAppSettings(_.cloneDeep(App.settings));
    }

    public static clearSignInData(): void {
        loadMeControl(null, null, null, false, null);
        App.clearTag("vs-otuid");
        App.clearTag("vote-userid");
        App.clearTag("vs-providerid");
        App.clearTag("vsts-email");
        App.clearTag("vsts-displayname");
        App.settings.template.user = "";
        Actions.setAppSettings(_.cloneDeep(App.settings));
    }

    public static requestSignOut(): void {
        App.clearSignInData();
        Actions.setSignInState(SignInState.Prompt);
        platformActions.signOut();
    }

    public static checkForSignIn(): void {
        Helpers.processSignInPromise(platformActions.checkForSignIn(), false);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public static showUnexpectedError(error: any, canDismiss: boolean = true, isCritical: boolean = false, title: string = null): void {
        Actions.setGlobalNotification({
            type: "error",
            message: stringFromErrorOrAny(error),
            canDismiss,
            isCritical,
            title: title ?? ResourceStrings.unexpectedError()
        } as NotificationInfo);
    }

    public static initializeHomePage(): void {
        // @TODO: Remove
        // Actions.searchFor(App.GetActiveSearchInfo(appState).searchtext, App.GetActiveSearchInfoTarget(appState));
        // Actions.loadActivity(); // load my activity

        const options: Actions.SearchOptions = new Actions.SearchOptions();
        options.sort = Sort.active;
        options.filter = Filter.follow;
        options.updateCountsByType = true;

        // @TODO: Do we need this for June Devcom2
        // if (appState.followActiveTab === FollowTab.myProblems) {
        //     Actions.searchFor("", SearchInfoTarget.myProblems, options);
        // } else if (appState.followActiveTab === FollowTab.mySuggestions) {
        //     Actions.searchFor("", SearchInfoTarget.mySuggestions, options);
        // } else if (appState.followActiveTab === FollowTab.myActivity) {
        //     Actions.setActiveFollowTab(FollowTab.myProblems);
        //     Actions.searchFor("", SearchInfoTarget.myProblems, options);

        // } else {
        //     throw new Error(`Active Tab ${appState.followActiveTab} is not recognized, add a case for it above.`);
        // }
    }

    private static setTag(tagPrefix: string, tagValue: string | null): void {
        console.log(`${tagPrefix}: ${tagValue}`);
        let isTagFound: boolean = false;

        for (let i = 0; i < App.settings.template.tags.length; i++) {
            // eslint-disable-next-line security/detect-object-injection
            const tag: FeedbackTag = App.settings.template.tags[i];
            if (tag.type === tagPrefix) {
                tag.value = tagValue;
                isTagFound = true;
                break;
            }
        }

        if (!isTagFound) {
            App.settings.template.tags.push({ type: tagPrefix, value: tagValue });
        }
    }

    public static clearTag(tagPrefix: string): void {
        App.setTag(tagPrefix, null);
    }

    private static startGettingScreenshot(): void {
        App.settings.screenshotThumb = null;
        const native: NativeActions = platformActions.getNativeActions();
        if (native == null) {
            return;
        }

        native.getScreenshot(!!App.settings.screenshotThumbPath).then((imageInfo: ImageInfo) => {
            console.log("******** Received screenshot ********");
            console.log(imageInfo);
            App.settings.screenshotThumb = imageInfo;
        }).catch((reason) => {
            console.log(reason); // ignore errors, since screenshot is non-essential
        });
    }

    /** item is typically from App.settings.template */
    public static getVsid(item: PublicFeedback): string {
        let vsid: string = "unknown";
        const tags: FeedbackTag[] = item.tags;
        for (let i = 0; i < tags.length; i++) {
            // eslint-disable-next-line security/detect-object-injection
            const tag: FeedbackTag = tags[i];
            if (tag.type === 'vs-otuid') {
                vsid = tag.value || "unknown";
                break;
            }
        }

        return vsid;
    }

    public static getSystemLogsToUpload(): FileInfo[] {
        const systemLogs: FileInfo[] = [];
        if (App.settings.filesToUpload != null) {
            App.settings.filesToUpload.forEach((filePath: string) => {
                systemLogs.push({ path: filePath, name: filePath.substr(filePath.lastIndexOf("\\") + 1), isUserFile: false });
            });
        }

        return systemLogs;
    }

    public static startUploadingFiles(feedbackId: string, state: AppState): void {
        const spaceConfig = getSpaceConfig(state.reportSpaceId);
        if (!spaceConfig) {
            console.error("Invalid space specified for upload");
            return;
        }
        if (state.rapPostType !== EntryValue.problem) {     // we allow native attachments for problems only
            console.log("Skipping native upload for suggestions");
            return;
        }
        if (!spaceConfig.reportProblemConfig?.isNativeProcessRequired) {     // Only do native uploads if space config allows it
            console.log("Skipping native upload as specified for this space");
            return;
        }

        let screenshot: ScreenshotCropConfig | null = null;
        const config: Collector.FileUploadConfig = new Collector.FileUploadConfig();
        config.feedbackId = feedbackId;
        config.feedbackSessionId = App.settings.feedbackSessionId;
        config.dataOptIn = App.settings.dataOptIn;

        config.uploadConfig.clientBuild = App.clientBuild;
        config.uploadConfig.clientName = App.clientName;

        if (state.reportIncludeScreenshot) {
            screenshot = {
                useThumbnailCropDimensions: true, // indicate that crop rect refers to thumbnail dimensions; will be scaled in native code for full image
                crop: null, // can be null if all screenshot is included
            };

            const crop: CropRect = state.reportCropRegion;
            if (crop != null) {
                screenshot.crop = {
                    left: crop.left,
                    top: crop.top,
                    width: crop.width(),
                    height: crop.height(),
                };
            }
        }

        config.files = config.files.concat(state.reportFilesToUpload.map((fileInfo: FileInfo) => fileInfo.path));

        if (state.reportIncludeSystemLogs) {
            config.files = config.files.concat(state.reportSystemFilesToUpload.map((fileInfo: FileInfo) => fileInfo.path));
        }

        if (state.reportIncludeScreenRecording && state.screenRecording) {
            Actions.rapSetScreenRecordingUploadState(OperationState.Executing, 0, null);
            uploadFiles(feedbackId,
                null,
                [new File([state.screenRecording], "ScreenRecording.webm", {
                    type: state.screenRecording.type,
                    lastModified: Date.now(),
                })],
                false,
                (_: UploadedFileInfo[]) => {
                    console.log("Screen recording uploaded successfully");
                    Actions.rapSetScreenRecordingUploadState(OperationState.Success, 100, null);
                    App.telemetry.postOperation("UploadScreenRecording", TelemetryResult.Success);
                },
                (error: any) => {
                    console.error("Error uploading screen recording file:", error);
                    Actions.rapSetScreenRecordingUploadState(OperationState.Failed, 0, stringFromErrorOrAny(error));
                    Actions.setGlobalNotification({
                        type: "error",
                        canDismiss: true,
                        title: "Error uploading screen recording",
                        message: stringFromErrorOrAny(error),
                    });
                    App.telemetry.postOperation("UploadScreenRecording", TelemetryResult.Failure, stringFromErrorOrAny(error));
                },
                (progressPercent: number) => {
                    console.log("Video upload progress:", progressPercent);
                    Actions.rapSetScreenRecordingUploadState(OperationState.Executing, progressPercent, null);
                },
                true, // prefixTimestampToName
            );
        }

        if ((config.files.length === 0) && (!state.reportIncludeScreenshot)) { // if nothing to upload
            return;
        }

        const native: NativeActions = platformActions.getNativeActions();
        if (native == null) {
            return;
        }

        native.startUploadingFiles(config, screenshot).catch((reason) => {
            console.log(reason); // ignore file upload errors; TODO: show error?
        });
    }

    private static readerHelper: HTMLSpanElement | null = null;
    // reads the specified text in case screen reader is active
    public static read(text: string): void {
        if (!text) {
            return;
        }

        console.log(`READ: '${text}'`);
        if (App.readerHelper == null) {
            App.readerHelper = document.getElementById("readerHelper");
        }

        if (App.readerHelper != null) {
            App.readerHelper.textContent = "";
            setTimeout(() => {
                App.readerHelper!.textContent = text;
            }, 100);
        }
    }

    private static getFilesRecursive(folderPath: string, startDate: Date): FileInfo[] {
        // @TODO: Replace with new equivalent
        ////const fileContents = fs.readdirSync(folderPath);
        const fileTree: FileInfo[] = [];

        ////fileContents.forEach((fileOrFolderName: string) => {
        ////    const currentPath: string = folderPath + '/' + fileOrFolderName;
        ////    const stats = fs.lstatSync(currentPath);

        ////    if (stats.isDirectory()) {
        ////        fileTree = fileTree.concat(App.getFilesRecursive(currentPath, startDate));
        ////    } else if (stats.mtime >= startDate) {
        ////        fileTree.push({ path: currentPath, name: fileOrFolderName });
        ////    }
        ////});

        return fileTree;
    }

    private static addFolderToUploadRecursive(folderPath: string, daysAgo: number): FileInfo[] {
        // @TODO: Replace with new equivalent
        return [];

        //     try {
        //         if (!fs.existsSync(folderPath)) {
        //             App.telemetry.postUserTask("LogData", TelemetryResult.Failure, `The ${folderPath} folder doesn't exist`);
        //             return [];
        //         }

        //         const ONE_DAY = 1000 * 60 * 60 * 24;   // 1,000 ms * 60 s * 60 mins * 24 hrs
        //         const startDate: Date = new Date((new Date().getTime()) - (ONE_DAY * daysAgo));

        //         const files: FileInfo[] = App.getFilesRecursive(folderPath, startDate);
        //         if (files.length === 0) {
        //             App.telemetry.postUserTask("LogData", TelemetryResult.Failure, `There is nothing in the ${folderPath} folder`);
        //             return [];
        //         }

        //         return files;
        //     } catch (error) {
        //         App.telemetry.postUserTask("LogData", TelemetryResult.Failure, `Error getting files from ${folderPath} folder: ${error.stack}`);
        //         return [];
        //     }
    }

    private static getUserSettingsFilePath(): string {
        return undefined;

        // @TODO: Replace with new equivalent
        ////const rootPath = remote.app.getPath("appData") + '\\ReportProblem';
        ////try {
        ////    fs.mkdirSync(rootPath);
        ////}
        ////catch (e) {
        ////}
        ////return rootPath + '\\vsfeedback.cfg.json';
    }

    public static saveUserSettings(): void {
        // @TODO: Replace with new equivalent
        // try {
        //     fs.writeFileSync(App.getUserSettingsFilePath(),
        //         JSON.stringify((App.store.getState() as AppState).user_local_settings),
        //         { encoding: 'utf8' });
        // }
        // catch (e) {
        //     console.log("Error saving settings");
        //     console.log(e);
        // }
    }

    private static loadUserSettings(): UserSettings {
        return new UserSettings();
        // @TODO: Replace with new equivalent
        //try {
        //    const text: string = fs.readFileSync(App.getUserSettingsFilePath(), "utf8");
        //    const settings: UserSettings = JSON.parse(text);
        //    return settings;
        //}
        //catch (e) {
        //    console.log("Error loading settings");
        //    console.log(e);
        //    return new UserSettings();
        //}
    }

    // parse and return tag information, e.g. "[tag [name]]" or "[tagName]"
    private static getTagSpan(text: string, nextIndex: number): TagSpan | null {
        const startIndex: number = text.indexOf('[', nextIndex);
        if (startIndex < 0) {
            return null;
        }

        let currIndex: number = startIndex + 1;
        let bracketCount: number = 1; // We've already found the opening bracket
        
        while (currIndex < text.length && bracketCount > 0) {
            // eslint-disable-next-line security/detect-object-injection
            if (text[currIndex] === '[') {
                bracketCount++;
                // eslint-disable-next-line security/detect-object-injection
            } else if (text[currIndex] === ']') {
                bracketCount--;
                if (bracketCount === 0) {
                    return { startIndex, endIndex: currIndex };
                }
            }

            currIndex++;
        }
        
        // If we reach here, we didn't find a matching closing bracket
        return null;
    }

    // parse and return user information, e.g. "user:[author name]" will return "author name"
    private static getUserSpan(text: string, nextIndex: number): TagSpan | null {
        let startIndex: number = text.indexOf('user:[', nextIndex);
        if (startIndex < 0) {
            return null;
        }
        startIndex += 6;
        let currIndex: number = startIndex + 1;
        while (currIndex < text.length) {
            // if the user filter has input with [MSFT], include [MSFT] in author name.
            if (text[currIndex] === '[' && currIndex + 6 <= text.length && text.substring(currIndex, currIndex + 6) === '[MSFT]') {
                return { startIndex, endIndex: currIndex + 6 };
            }
            if (text[currIndex] === ']') {
                return { startIndex, endIndex: currIndex };
            }
            currIndex++;
        }
        return null;
    }

    public static getTags(searchText: string): TagsResult {
        const result: TagsResult = new TagsResult();
        result.text = searchText;

        let nextIndex: number = 0;
        const tagsArr: TagSpan[] = [];
        // eslint-disable-next-line no-constant-condition
        while (true) {

            const userTag: TagSpan | null = App.getUserSpan(searchText, nextIndex);
            if (userTag != null) {
                const userNameLength = userTag.endIndex - userTag.startIndex;
                result.userName = searchText.substr(userTag.startIndex, userNameLength);
                searchText = (searchText.substr(0, userTag.startIndex - 6) + searchText.substr(userTag.endIndex + 1)).trim();
            }

            const tag: TagSpan | null = App.getTagSpan(searchText, nextIndex);
            if (tag == null) { // if no tags left
                break;
            }
            nextIndex = tag.endIndex + 1;

            const tagName: string = searchText.substr(tag.startIndex + 1, tag.endIndex - tag.startIndex - 1);
            tagsArr.push(tag);

            if ((tagName.trim() !== "") && (!result.tagsDict[tagName.toLocaleLowerCase()])) {
                result.tags.push(tagName);
                result.tagsDict[tagName.toLocaleLowerCase()] = true;
            }
        }

        for (let i = tagsArr.length - 1; i >= 0; i--) {
            // eslint-disable-next-line security/detect-object-injection
            const tag: TagSpan = tagsArr[i];
            searchText = (searchText.substr(0, tag.startIndex) + searchText.substr(tag.endIndex + 1)).trim();
        }
        result.textNoTags = searchText;

        return result;
    }

    /** Adds selected tags to markdown from the description editor */
    public static getReportDetails(state: AppState, markdown: string): string {
        if (!state.reportIsRegression && state.reportSeverityText === "") { // if there's nothing to add
            return markdown;
        }

        const resultTags: string[] = [];
        if (state.reportSeverityText !== "") {
            resultTags.push(`[severity:${state.reportSeverityText}]`);
        }

        if (state.reportIsRegression) {
            resultTags.push(`[regression]`);
            if (state.reportWorkedInText !== "") {
                const workedInText: string = state.reportWorkedInText.replace(/\[|\]|:/g, "");
                resultTags.push(`[worked-in:${workedInText}]`);
            }
        }

        return resultTags.join(" ") + "\r\n" + markdown;
    }

    public static submitClick(state: AppState, reportType: string, additionalTags: FeedbackTag[] = null, allowedTemplateTagTypes: string[] = null): void {
        switch (reportType) {
            case ReportType.newProblem: {
                if (!state.reportNextEnabled) {
                    return;
                }
                App.telemetry.postBusinessEvent("submitrap-clicked", this.getExtraProperties(state, ""));
                Actions.reportProblem(state.reportTitle, App.getReportDetails(state, state.reportDetail), additionalTags, allowedTemplateTagTypes);
                break;
            }
            case ReportType.vote: {
                App.telemetry.postBusinessEvent("submitev-clicked", this.getExtraProperties(state, state.evComment));

                if (state.selectedItem == null) {
                    throw new Error("E_SELECTED_ITEM_IS_NULL (submit_click)");
                }
                Actions.voteFor(state.selectedItem, true, state.evComment);
                break;
            }
            case ReportType.provideInfoComment: {
                if (!state.nmiNextEnabled) {
                    return;
                }
                App.telemetry.postBusinessEvent("submitnmi-clicked", this.getExtraProperties(state, state.nmiComment));

                if (state.selectedItem == null) {
                    throw new Error("E_SELECTED_ITEM_IS_NULL (submit_click)");
                }

                const rootPost: RootPost | null = state.ticketsById[state.selectedItem.answerHubId]?.data;
                if (rootPost == null) {
                    throw new Error("E_SELECTED_ROOT_POST_IS_NULL (submit_click)");
                }

                const lastNeedMoreInfoCommentId = getLastNeedMoreInfoCommentId(rootPost, rootPost.id);

                Actions.addComment({
                    item: state.selectedItem,
                    commentText: state.nmiComment,
                    parentId: lastNeedMoreInfoCommentId,
                    visibility: Actions.NodeVisibility.all,
                    isProvideInfo: true
                });
                break;
            }
            default: break;
        }

        Actions.setRapView(RapView.result);

        const close = document.getElementById('close');
        if (close != null) {
            close.focus();
        }
    }

    public static getExtraProperties(state: AppState, text: string): { [key: string]: string } {
        return {
            includesScreenshot: state.reportIncludeScreenshot ? "Yes" : "No",
            attachedFileCount: state.reportFilesToUpload.length.toString(),
            text: text,
        };
    }

    // needed because we post different events based on context (e.g. attachments in enhanced vote vs report problem)
    public static getEventNameForReportType(eventName: string, reportType: ReportType): string {
        let telemetryAdd: string = "";

        switch (reportType) {
            case ReportType.vote: {
                telemetryAdd = "ev"; break;
            }
            case ReportType.provideInfoComment: {
                telemetryAdd = "nmi"; break;
            }
            default: break;
        }
        if (reportType !== ReportType.newProblem) {
            // add "ev"/"nmi" before the dash or end of event name
            const dashIndex = eventName.indexOf('-');
            if (dashIndex < 0) {
                eventName = eventName + telemetryAdd;
            }
            else {
                eventName = eventName.substr(0, dashIndex) + telemetryAdd + eventName.substr(dashIndex);
            }
        }
        return eventName;
    }

    public static closeDialog(state: AppState, reportType: string): void {
        // @TODO: Replace with new equivalent
        ////ipcRenderer.removeAllListeners("running-vs-instances");
        let telemetryEventName: string = "";
        switch (reportType) {
            case ReportType.newProblem: {
                telemetryEventName = "CloseNewProblemClick"; break;
            }
            case ReportType.vote: {
                telemetryEventName = "CloseEnhanceVoteClick"; break;
            }
            case ReportType.provideInfoComment: {
                telemetryEventName = "CloseNeedMoreInfoClick"; break;
            }
            default: break;
        }
        if (state.is_parent_vs_instance_running) {
            Actions.setDialog(Dialog.none);
            App.telemetry.postUserTask(telemetryEventName, TelemetryResult.Success, undefined, undefined, {
                "CurrentView": state.rapView,
            });
        } else {
            Actions.setMainView(MainView.noinstance);
            App.telemetry.postUserTask(telemetryEventName, TelemetryResult.Success, "Parent VS Instance is no longer running", undefined, {
                "CurrentView": state.rapView,
            });
        }
    }

    public static isTicketReadonly(currentState: string, lastStateChangeDaysAgo: number): boolean {
        return currentState === ProblemStates.fixed && lastStateChangeDaysAgo > ticketReadonlyThresholdDays;
    }

    public static canAddComment = (ticket: RootPost | null, isTicketReadOnly: boolean): boolean => {
        if (!ticket) {
            return false;
        }
        const stateConfig = ticket.type === PostType.suggestion ? ideaStates[ticket.state] : problemStates[ticket.state];
        return (!stateConfig || !stateConfig.commentsLocked) && !isTicketReadOnly;
    }

    public static canAddSolution = (ticket: RootPost | null, isTicketReadOnly: boolean): boolean => {
        if (!ticket) {
            return false;
        }
        const stateConfig = problemStates[ticket.state];
        return (!stateConfig || !stateConfig.solutionsLocked) && !isTicketReadOnly;
    }

    public static canAddReaction = (ticket: RootPost | null, isTicketReadOnly: boolean): boolean => {
        if (!ticket) {
            return false;
        }
        const stateConfig = problemStates[ticket.state];
        return (!stateConfig || !stateConfig.reactionsLocked) && !isTicketReadOnly;
    }
}

class TagSpan {
    public startIndex: number;
    public endIndex: number;
}

class DisableFocusForRoot {
    private isShiftKeyDown: boolean;
    private isTabKeyDown: boolean;

    /**
     * Prevents focus from leaving root's children.
     * Needed for accessibility to disallow focusing on the <body> tag
     * @param doc The document to check focus on
     * @param root The root to prevent focus from leaving
     * @param canFocusRoot true if we can focus on the root element, false if not
     */
    constructor(doc: Document, root: HTMLElement) {
        // check if Shift key is up or down
        root.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key && event.key.toLowerCase() === "shift") {
                this.isShiftKeyDown = true;
            }

            if (event.key && event.key.toLowerCase() === "tab") {
                this.isTabKeyDown = true;
            }
        });

        root.addEventListener("keyup", (event: KeyboardEvent) => {
            if (event.key && event.key.toLowerCase() === "shift") {
                this.isShiftKeyDown = false;
            }

            if (event.key && event.key.toLowerCase() === "tab") {
                this.isTabKeyDown = false;
            }
        });

        // ensure focus stays in "root"
        const focusIn = (event: FocusEvent): void => {
            if (!this.isTabKeyDown) { // if not keyboard focus, return since people want to select what the point the mouse to
                return;
            }

            event.stopPropagation();
        };

        const focusOut = (event: FocusEvent): void => {
            if (!this.isTabKeyDown) { // if not keyboard focus, return since people want to select what the point the mouse to
                return;
            }

            // Stop propagation since this handler will handle the focus.
            event.stopPropagation();

            const element = event.relatedTarget as HTMLElement;

            // If the target is not valid, the root does not contain it,
            // or it is the root, reset focus
            if (!element || !root.contains(element) || root.isEqualNode(element)) {
                event.preventDefault();
                this.resetFocus(doc, root, this.isShiftKeyDown);
            }
        };

        root.addEventListener("focusin", focusIn as any);
        root.addEventListener("focusout", focusOut as any);
    }

    private resetFocus(doc: Document, root: HTMLElement, fromEnd: boolean): void {
        // the root element is visible, so handle focus
        if (!doc.contains(root)) {
            return;
        }

        // We need to request a frame to show the focus change
        requestAnimationFrame(() => {
            // walk the children testing focus. Go in reverse if fromEnd is true
            const children = root.querySelectorAll("*") as NodeListOf<HTMLElement>;
            const list = new NodeListIterator(children, fromEnd);
            let current = list.begin();
            while (current) {
                current.focus();

                if (current === doc.activeElement) {
                    return;
                }

                current = list.next();
            }
        });
    }
}

/* istanbul ignore next */
class NodeListIterator<T extends Node> {
    private _nodeList: NodeListOf<T>;
    private _reverse: boolean;
    private _index = 0;

    constructor(nodeList: NodeListOf<T>, reverse: boolean) {
        this._reverse = reverse;
        this._nodeList = nodeList;

        if (this._reverse) {
            this._index = this._nodeList.length - 1;
        }
    }

    /**
     * @returns {T} - the next element in the list, or undefined if
     *                there are no more elements left.
     */
    public next(): T {
        if (this._reverse) {
            return this._nodeList[this._index--];
        }

        return this._nodeList[this._index++];
    }

    public begin(): T {
        if (this._reverse) {
            return this._nodeList[this._nodeList.length - 1];
        }

        return this._nodeList[0];
    }
}
